<template>
  <b-card
    class="card-tiny-line-stats"
    body-class="pb-50"
  >
    <b-card-header>
      <div class="d-flex align-items-center mb-2">
        <feather-icon
          size="24"
          class="mr-1"
          icon="ZapIcon"
        />
        <b-card-title class="ml-25">
          {{ $t('Latest Updates') }}
        </b-card-title>
      </div>
    </b-card-header>

    <b-card-body>
      <app-timeline>
        <app-timeline-item
          v-for="(announcement, index) in announcements"
          :key="index"
          :title="announcement.text"
          :time="announcement.date"
          variant="primary"
        />
      </app-timeline>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    AppTimeline,
    AppTimelineItem,
  },
  data() {
    return {
      announcements: [
        {
          text: this.$t('Standing Order feature is now available'),
          date: this.$t('March, 2025'),
          url: '#',
          target: '_blank',
        },
        {
          text: this.$t('Exclusive: You can now Cancel the same-day transaction'),
          date: this.$t('March, 2025'),
          url: '#',
          target: '_blank',
        },
        {
          text: this.$t('Loan Repayment Schedule Update (Single & Batch) is now available'),
          date: this.$t('March, 2025'),
          url: '#',
          target: '_blank',
        },
        {
          text: this.$t('General UX Improvements'),
          date: this.$t('March, 2025'),
          url: '#',
          target: '_blank',
        },
      ],
    }
  },
}
</script>

<style scoped>
.card .card-header {
    padding: 0.5rem 0;
}
.bulletin-list{
  font-size: 1.2rem;
}
.bulletin-list li{
  margin-top: 10px;
}
.section-title{
  font-weight: 800;
}
</style>
